import genererTier from '@/services/tiers/genererTiers';
import { TIERS_SOUS_TYPE_AUCUN, TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import set from 'lodash/set';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';

function getParametreIdFromStore(nom, value) {
  return store.getters['parametres/parametre'](PARAMETRES_KEYS[nom])?.find((param) => {
    return param.libelle.toLowerCase().trim() === value?.toLowerCase()?.trim();
  })?.id ?? null;
}

export function fillClientWithData(client, ligne) {
  const banColumnAuto = ['modeReglement', 'motifBlocage', 'civilite'];
  const boolColumn = ['prospect', 'archive'];
  const keys = Object.keys(ligne);
  // fait tout les columns facile
  for (let i = 0; i < keys.length; i += 1) {
    if (!banColumnAuto.includes(keys[i])) {
      const val = boolColumn.includes(keys[i]) ? booleanConverter(ligne[keys[i]]) : ligne[keys[i]];
      set(client, keys[i], val);
    }
  }
  if (client.adresseFacturation?.ville) client.AdresseFacturationDifferente = true;
  client.modeReglementId = getParametreIdFromStore('modeReglement', ligne.modeReglement);
  client.motifBlocageId = getParametreIdFromStore('motifBlocage', ligne.motifBlocage);
  client.tiersMarques = client.tiersMarques
    ? client.tiersMarques.map(m => ({ marqueId: getParametreIdFromStore('marque', m) }))
    : [];
  client.societeId = store.getters['societe/societeActiveId'];
  client.referenceExterne = ligne.code;
  return client;
}

export default function genererClient(ligne) {
  const client = genererTier();
  client.type = TIERS_TYPE_CLIENT;
  client.sousTypes = [TIERS_SOUS_TYPE_AUCUN];
  return fillClientWithData(client, ligne);
}
